import { render, staticRenderFns } from "./CommPVList.vue?vue&type=template&id=3bd64504&"
import script from "./CommPVList.vue?vue&type=script&lang=js&"
export * from "./CommPVList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports